<template>
  <div v-if="notification.id != undefined">
    <b-alert show variant="secondary" class=" mb-2">{{$t('NOTIFICATION')}} : {{$t('MESSAGE_STATUS.' + notification.status)}}
      <p v-if="notification.information">
       {{notification.information}}
      </p>
    </b-alert>
    
  </div>
</template>
<script>
export default {
  props: ["notification", "user_uuid", "functionbox_uuid"],
  data() {
    return {
    };
  },
  methods: {
    onLoad: function() {
      let self = this;
      if(this.notification.id != undefined)
      {
        this.$http
          .post(this.user.hostname + "/inbox/notification/viewed", {
            functionbox_uuid: this.functionbox_uuid,
            user_uuid: this.user_uuid,
            notificationId: this.notification.id
          })
          .then(() => {
          })
          .catch((error) => {
            self.loading = false;
            if(error.toString() == "Error: fail_4_4") return;
            self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
          });
      }
    },
  },
  mounted(){
    this.onLoad();
  }
};
</script>
<style></style>
